import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { CardLayoutComponent } from '../shared/card-layout/card-layout.component';
import { Store } from '@ngrx/store';

@Component({
    selector: 'app-discounts',
    imports: [CardLayoutComponent],
    template: `
        <app-card-layout
            (click)="isActive = !isActive"
            [isActive]="isActive"
            title="Discounts & Surcharges"
            icon="discounts"
            subtitle="Discounts & Surcharges"
            [isLoading]="isDCPolicyLoaded"
            [failed]="dcPolicyFailed"
            [columns]="['DISCOUNT NAME', 'LIMIT', 'PREMIUM']"
            [fields]="fields"
            (retry)="retryDCPolicy()"
        ></app-card-layout>
    `,
})
export class DiscountsComponent {
    isActive = false;
    @Input() isDCPolicyLoaded = false;
    @Input() dcPolicyFailed = false;
    @Output() retry = new EventEmitter<void>();
    private store = inject(Store);
    policySignal = this.store.selectSignal((state: any) => state.policy);

    private formatCurrency(value: any): string {
        const num = Number(value);
        const safe = isNaN(num) ? 0 : num;
        const abs = Math.abs(safe).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        return safe < 0 ? `-$${abs}` : `$${abs}`;
    }

    get fields() {
        const policyState = this.policySignal();
        const policyNum = policyState.policyNumber;
        const snapshot = policyState.data?.[policyNum]?.policySnapshot;

        const discountFields = snapshot?.discounts
            ? Object.values(snapshot.discounts).map((v: any) => ({
                  caption: v.node,
                  value: v.value,
                  premium: this.formatCurrency(v.premium ?? 0),
              }))
            : [];

        const surchargeFields = snapshot?.surcharges
            ? Object.values(snapshot.surcharges).map((v: any) => ({
                  caption: v.node,
                  value: v.value,
                  premium: this.formatCurrency(v.premium ?? 0),
              }))
            : [];

        return [...discountFields, ...surchargeFields];
    }

    retryDCPolicy() {
        this.retry.emit();
    }
}
